module.exports = __webpack_public_path__ + "img/vue1-corpsavant_lavande.9593bf70.png";